import { css } from '@/styled-system/css';

export const carouselHeaderStyles = css.raw({
  display: 'grid',
  alignItems: 'center',
  gridAutoFlow: 'column',
  gridGap: 'looser',
  justifyContent: 'space-between',
  paddingBlockEnd: 'tighter',
});
